const mutations = {
    setStatusList(state, data) {
        state.statusList = data;
    },
    setStatus(state, data) {
        state.status = data;
    },
    resetStatus(state) {
        state.status = {
            label: ""
        }

    }
}
export default mutations;